export default __webpack_public_path__ + "static/media/leetcodeIcon.26900637.svg";